import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/es-mx';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { customTheme } from './AppStyle';
import { ThemeProvider } from '@mui/material/styles';
import StoreProvider from './Store';
import NotificationProvider from './Providers/NotificationProvider';
import { FlowProvider } from './Providers/FlowProvider';
import { InternalRouter } from './Components/InternalRouter';
import { CookiesBlockedAlert } from './Components/_common/CookiesBlockedAlert/CookiesBlockedAlert';
import { localStorageUtil } from './utils/localStorageUtils';
import { useWindowQuery } from './Hooks/useWindowQuery';
import { mainStore } from './Providers/mainStore';
import './i18n';

// timezone plugin depends on utc, so it must be extended first
dayjs.extend(utc);
dayjs.extend(timezone);

const App = () => {
  const queryParams = useWindowQuery();
  const initVerify = queryParams.get('init-verify');

  if (initVerify) {
    localStorageUtil.setCustomParams({ name: 'initVerify', value: initVerify });
  }

  if (!navigator.cookieEnabled) {
    return <CookiesBlockedAlert />;
  }

  return (
    <Provider store={mainStore}>
      <StoreProvider>
        <NotificationProvider>
          <FlowProvider>
            <LocalizationProvider
              // utils={DayJsUtils}
              dateAdapter={AdapterDayjs}
              adapterLocale="es-mx"
            >
              <div
                style={{
                  textAlign: 'center',
                  backgroundColor: '#ffffff',
                  minHeight: '100vh',
                }}
              >
                <ThemeProvider theme={customTheme}>
                  <InternalRouter />
                </ThemeProvider>
              </div>
            </LocalizationProvider>
          </FlowProvider>
        </NotificationProvider>
      </StoreProvider>
    </Provider>
  );
};
export default App;
